import { Box, Card, CardHeader, Skeleton, Stack } from '@mui/material';
import { SEVERITY_COLORS, Severity } from '../../../../../common/enums/Severity';

const PriorityFixCard = () => {
  return (
    <Box
      sx={{
        display: 'block',
        mb: 0.25,
        borderLeft: '3px solid',
        borderLeftColor: SEVERITY_COLORS[Severity.NO_WARNING].main,
        '&:not(:first-of-type)': {
          borderTop: `1px solid`,
          borderTopColor: 'grey.300',
        },
        px: 2,
        py: 1,
      }}
    >
      <Box sx={{ width: '100%', overflow: 'hidden' }}>
        <Stack direction={'row'} spacing={1} sx={{ mb: 0.375 }}>
          <Skeleton variant="rectangular" width={16} height={16} />
          <Skeleton variant="rectangular" width={102} height={16} />
        </Stack>
        <Skeleton variant="rectangular" width={300} height={16.5} sx={{ my: 0.875 }} />
        <Skeleton variant="rectangular" width={250} height={16} sx={{ my: 0.25 }} />
      </Box>
    </Box>
  );
};

export const PriorityFixes = () => {
  return (
    <Card elevation={2}>
      <CardHeader title={<Skeleton variant="rectangular" width={100} height={14} sx={{ my: 1.125 }} />} />
      <Box sx={{ p: 0, pb: 1 }}>
        {Array(10)
          .fill('')
          .map((_, idx) => (
            <PriorityFixCard key={idx} />
          ))}
      </Box>
    </Card>
  );
};
